import { render, staticRenderFns } from "./BillingUsage.vue?vue&type=template&id=033ff3a8&scoped=true&"
import script from "./BillingUsage.vue?vue&type=script&lang=ts&"
export * from "./BillingUsage.vue?vue&type=script&lang=ts&"
import style0 from "./BillingUsage.vue?vue&type=style&index=0&id=033ff3a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033ff3a8",
  null
  
)

export default component.exports